"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createReducer = _interopRequireDefault(require("./createReducer"));

var _plain = _interopRequireDefault(require("./structure/plain"));

var _default = (0, _createReducer["default"])(_plain["default"]);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/reducer.js
// module id = 902
// module chunks = 0